import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTie, faIdCard } from '@fortawesome/free-solid-svg-icons';
import Footer from '../Footer/FooterWrapper';
import { Link } from 'react-router-dom';
import './BrokerStart.css';
import { useLanguage } from '../../i18n/LanguageContext';

const BrokerStart = () => {
  const { t } = useLanguage();

  return (
    <>
      <div className="broker-container">
        <h2><FontAwesomeIcon icon={faUserTie} className="broker-icon" /> {t('brokerStart.title')}</h2>
        
        <div className="login-section">
          <p>{t('brokerStart.intro')}</p>
        </div>
        
        <div className="broker-item">
          <h3>{t('brokerStart.forBrokersTitle')}</h3>
          <p>{t('brokerStart.forBrokersBody1')}</p>
          <p>{t('brokerStart.forBrokersBody2')}</p>
        </div>

        <div className="broker-item">
          <h3>{t('brokerStart.benefitsTitle')}</h3>
          
          <div className="benefit-item">
            <h4>{t('brokerStart.leadTitle')}</h4>
            <p>{t('brokerStart.leadBody')}</p>
          </div>

          <div className="benefit-item">
            <h4>{t('brokerStart.timeTitle')}</h4>
            <p>{t('brokerStart.timeBody')}</p>
          </div>
          
          <div className="benefit-item">
            <h4>{t('brokerStart.transparentTitle')}</h4>
            <p>{t('brokerStart.transparentBody')}</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BrokerStart; 
